import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { api } from '../../../models/api-url.model';
import { BillingPreferences } from '../../../models/billing-preferences.model';
import { BillingSummary } from '../../../models/billing-summary.model';
import { ContentDocumentLink } from '../../../models/content-document-link.model';
import { CurrentBill } from '../../../models/current-bill.model';
import { Invoice } from '../../../models/invoice.model';
import { Payment } from '../../../models/payment.model';
import { ApiService } from '../api';
import { FileAPI } from '../attachment';

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  private readonly apiService = inject(ApiService);

  getPayments(): Observable<Payment[]> {
    return this.apiService.get(api.paymentsURL);
  }

  getInvoices(): Observable<Invoice[]> {
    return this.apiService.get(api.invoicesURL);
  }

  getSummary(): Observable<BillingSummary> {
    return this.apiService.get(api.billingSummaryURL);
  }

  getCurrentBill(): Observable<CurrentBill> {
    return this.apiService.get(api.currentBillURL);
  }

  getPaymentLink(): Observable<{ paymentUrl: string }> {
    return this.apiService.get(api.paymentLinkURL);
  }

  getPreferences(): Observable<BillingPreferences> {
    return this.apiService.get(api.billingPreferencesURL);
  }

  getInvoiceBlobById(contentVersionId: string): Observable<FileAPI> {
    return this.apiService
      .get(`${api.invoiceAttachmentURL}/${contentVersionId}/file`, {
        responseType: 'arraybuffer',
      })
      .pipe(
        map((data) => {
          const blob = new Blob([data], { type: 'application/pdf' });
          return { binaryData: data, url: window.URL.createObjectURL(blob) };
        }),
      );
  }

  getInvoiceBlob(file: ContentDocumentLink): Observable<FileAPI> {
    return this.getInvoiceBlobById(
      file.ContentDocument.LatestPublishedVersionId,
    );
  }
}
